import React, { useState, useEffect } from 'react';
import { Modal, Button, Spin } from 'antd';
import api from '../../../../api';
import Step1 from '../../../Front/Orders/Steps/Step1';
import useSearch from '../../../../hooks/useSearch';

function AddOrder({ trailId, afterAdd }) {
  const { date: initialDate } = useSearch();

  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState([]);

  // pricing 
  const [pricing, setPricing] = useState({});

  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(initialDate); // "2022-02-11" <- date format is YYYY-MM-DD 
  const [hour, setHour] = useState('');
  const [trail, setTrail] = useState({});
  const [slots, setSlots] = useState([]);
  const [slot, setSlot] = useState({});
  const [equipments, setEquipments] = useState([]); 
  const [price, setPrice] = useState(0);
  const [recipient, setRecipient] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });


  // get init data
  useEffect(() => {
      const findTrail = async () => {
          try {
              const data = await api.findTrail(trailId);
              setTrail(data);
          } catch (error) {
              alert(
                  'Coś poszło nie tak. Odśwież stronę lub spróbuj ponownie później.',
              );
          }
      };
      findTrail();
  }, []);

  const fetchSlostData = async () => {
    let data = await api.findAvailableEquipments(trailId, date, equipments);
    data = data.filter(slot => slot.startTime > (new Date()).toISOString());
    setSlots(data)
  }

  useEffect(() => {
      const getSlots = async () => {
          try {
              fetchSlostData();
          } catch (error) {
              alert(
                  'Coś poszło nie tak. Odśwież stronę lub spróbuj ponownie później.',
              );
          }
      };
      getSlots();
  }, [date, equipments]);

  useEffect(() => {
    setSlot({});
    setHour('');
  }, [date]);

  // calculate price
  useEffect(() => {
      const getPrices = async () => {
          fetchSlostData();

          // aktualizuj cene przy zmiane dania, ilosci, godziny
          const selectedDate = slot.startTime || new Date(date);
          const pricing = await api.getPrices(
              trailId,
              selectedDate,
              equipments,
          );
          setPricing(pricing);
          setPrice(pricing.newTotalPrice || pricing.totalPrice);
      };
      getPrices();
  }, [equipments, slot, date]);

  const submit = async () => {
    if (!equipments.length) {
      setErrors(['Wybierz pozycje']);
      setLoading(false)
      return;
    }
    if (!recipient.firstName) {
      setErrors(['Pierwsze imię jest wymagane']);
      setLoading(false);
      return;
    }
    setErrors([])

    const data = {
      trailId,
      price,
      equipments,
      userFirstName: recipient.firstName,
      date: slot.startTime,
      paymentChannelId: 1,
    }
    if (recipient.lastName) data.userLastName = recipient.lastName;
    if (recipient.email) data.userEmail = recipient.email;
    if (recipient.phone) data.userPhone = recipient.phone;

    setLoading(true);
    try {
      const isStillAvailable = await api.confirmAvailableEquipments(trailId, slot.startTime, equipments);
      if (!isStillAvailable) {
        setLoading(false);
        return;
      }

      const order = await api.makeOrder(data);
      afterAdd(order);
      setShowModal(false);
      // window.location.reload
    } catch(error) {
      console.log('Error:', error.response);
      if (error.response.data?.errors) {
        setErrors(Object.values(error.response.data?.errors || []));
      } else if (error.response.data?.message) {
        setErrors([error.response.data?.message]);
      } else {
        alert('Coś poszło nie tak. Spróbuj odświeżyć stronę. Jeśli problem wciąż występuje dokonaj rezerwacji telefonicznie');
      }
    }
    setLoading(false);
    fetchSlostData();
  }

  const onHourChange = hour => {
    setHour(hour);
    setSlot(hour ? slots.find(x => x.startTimeHuman === hour) : {});
  }
  const onFieldChange = (field, value) => {
    setRecipient({ ...recipient, [field]: value })
  }

  return (<>
    <Button type="primary" onClick={() => setShowModal(true)}>Dodaj rezerwację</Button>

    <Modal
      title={`Dodaj nową rezerwację`} 
      visible={showModal} 
      okText="Dodaj"
      cancelText="Anuluj"
      loading={loading}
      onOk={() => submit()} 
      onCancel={() => setShowModal(false)}
      width={700}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <p>Dane klienta</p>

          <div>
            <div className="form-group mb-3">
              <label htmlFor="fname" className="form-label">Imię <span className="text-danger">*</span></label>
              <input type="text" id="fname" value={recipient.firstName} onChange={e => onFieldChange('firstName', e.target.value)} className="form-control" />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="lname" className="form-label">Nazwisko</label>
              <input type="text" id="lname" value={recipient.lastName} onChange={e => onFieldChange('lastName', e.target.value)} className="form-control" />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="email" className="form-label">Email</label> 
              <input type="email" id="email" value={recipient.email} onChange={e => onFieldChange('email', e.target.value)} className="form-control" />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="phone" className="form-label">Telefon kontaktowy</label>
              <input type="text" id="phone"value={recipient.phone} onChange={e => onFieldChange('phone', e.target.value)} className="form-control" />
            </div>
          </div>

          
          <p>Pozycje</p>

          <Step1 
            date={date}
            onDateChange={setDate}
            hour={hour}
            onHourChange={onHourChange}
            equipmentsToTrail={trail.equipmentToTrail}
            slots={slots}
            equipments={equipments}
            onEquipmentsChange={setEquipments}
            hideTitle
            showHoursDetails
            pricing={pricing}
            showAllConditions
            // hoursType="select"
          /> 

          <p>Cena: {price} zł</p>
          
          {errors.length ? (
            <div className="alert alert-danger">
              <ul className="mb-0">
                {errors.map(error => <li>{error}</li>)}
              </ul>
            </div>
          ) : null}

      </Spin>

    </Modal>
  </>);
}

export default AddOrder;